<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Ik2Pd/tc-custom/9780226583990.jpg?1730578246149" alt="This image is the cover for the book Irony of American History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Irony of American History
      </h1>
      <p class="bookDescription body article font2">
        <p>“[Niebuhr] is one of my favorite philosophers. I take away [from his works] the compelling idea that there’s serious evil in the world, and hardship and pain. And we should be humble and modest in our belief we can eliminate those things. But we shouldn’t use that as an excuse for cynicism and inaction. I take away . . . the sense we have to make these efforts knowing they are hard.”—President Barack Obama Forged during the tumultuous but triumphant postwar years when America came of age as a world power, <i>The Irony of American History</i> is more relevant now than ever before. Cited by politicians as diverse as Hillary Clinton and John McCain, Niebuhr’s masterpiece on the incongruity between personal ideals and political reality is both an indictment of American moral complacency and a warning against the arrogance of virtue. Impassioned, eloquent, and deeply perceptive, Niebuhr’s wisdom will cause readers to rethink their assumptions about right and wrong, war and peace.<br/>  “The supreme American theologian of the twentieth century.”—Arthur Schlesinger Jr., <i>New York Times</i><br/> “Niebuhr is important for the left today precisely because he warned about America’s tendency—including the left’s tendency—to do bad things in the name of idealism. His thought offers a much better understanding of where the Bush administration went wrong in Iraq.”—Kevin Mattson, <i>The Good Society</i><br/>  <br/> “<i>Irony</i> provides the master key to understanding the myths and delusions that underpin American statecraft. . . . The most important book ever written on US foreign policy.”—Andrew J. Bacevich, from the Introduction</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Reinhold Niebuhr, Andrew J. Bacevich
      </h2>
      
      <p class="authorDescription body article"><B>Reinhold Niebuhr</B> (1892–1971)taught for many years at Union Theological Seminary,&#160;in New York City, as well as lecturing&#160;and preaching all over the country. The recipient of the Presidential Medal of Freedom in 1964, he is the author of many books, including <I>The Nature and Destiny of Man.</I><br> &#160;<br><B>Andrew J. Bacevich</B>, professor of international relations and history at Boston University, is the author of <I>The Long War</I>.&#160;&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?76c93994